import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { fetchAuthSession } from "aws-amplify/auth";
import { createEnhancedApolloErrorLink } from "./apolloErrorLink";

const graphQLUrl = import.meta.env.VITE_GRAPHQL_URL;

const httpLink = createHttpLink({ uri: graphQLUrl });

const authLink = setContext(async (_, { headers }) => {
  const session = await fetchAuthSession();
  const token = session?.tokens?.accessToken.toString();

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const errorLink = createEnhancedApolloErrorLink();

const graphQLClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: errorLink.concat(authLink.concat(httpLink)),
  connectToDevTools: false,
});

export default graphQLClient;
